import React from 'react';
import { find, trim } from 'ramda';
import {
    useParams, Link
} from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import './ConsignorView.scss';
export default function ConsignorView() {
    const { consignorID } = useParams();
    const consignorIDInt = parseInt(consignorID, 10);
    const consignor = find((c) => c.consignor_id === consignorID)(global.drupalSettings.catalogues.consignors_contacts);
    const main_color = consignor.main_color || global.drupalSettings.catalogues.main_color;
    const secondary_color = consignor.secondary_color || global.drupalSettings.catalogues.secondary_color;
    const logoDisplay = !consignor.logo ? null : (
        <div className="row consignor-logo justify-content-center">
            <div className="col-sm-6 text-center m-1">
                <img className="img-fluid" src={consignor.logo.replace('http://','https://')} alt="Consignor Logo" />
            </div>
        </div>
    );

    return (
        <>
            <div className='consignor-view container-fluid'>
            <div className="row top-header"
                style={{
                    backgroundColor: main_color,
                    color: secondary_color,
                }}
            >
                <div className="col">
                    <h1>
                        {global.drupalSettings.catalogues.sale_name}
                    </h1>
                </div>
            </div>
            {logoDisplay}
            <div className="row designer-details justify-content-center">
                <div className="col-lg-6">
                    <div className="row">
                        <div className="col-12 consignor-name">
                            <h2>
                                {consignor.consignor_name}
                            </h2>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6 consignor-address">
                            <p>
                                <span className="heading">Address:</span><br />
                                {consignor.address}
                            </p>
                        </div>
                        <div className="col-md-6 consignor-contact">
                            <p>
                                {consignor.email && (<span><span className="heading">Email: </span> <a href={`mailto:${consignor.email}`}>{consignor.email}</a></span>)}<br />
                                {consignor.fax && (<span><span className="heading">Fax: </span> {consignor.fax}<br /></span>)}
                                {consignor.mobile && (<span><span className="heading">Mobile Phone: </span> {consignor.mobile}<br /></span>)}
                                {consignor.phone && (<span><span className="heading">Phone: </span> {consignor.phone}<br /></span>)}
                            </p>
                        </div>
                    </div>
                    <div className="row buttons-group">
                        <div className="col-12 actions">
                            { consignor.url &&
                                <a
                                    style={{
                                        backgroundColor: main_color,
                                        color: secondary_color,
                                    }}
                                    className="consignor-website"
                                    href={consignor.url}
                                    target="_blank"
                                >
                                        Consignor Website
                                </a>                            
                            }
                            { consignor.facebook &&
                                <a
                                    className="consignor-social"
                                    href={consignor.facebook}
                                    target="_blank"
                                >
                                    <FontAwesomeIcon icon={['fab', 'facebook-f']} size="lg" />
                                </a>
                            }
                            { consignor.twitter &&
                                <a
                                    className="consignor-social"
                                    href={consignor.twitter}
                                    target="_blank"
                                >
                                    <FontAwesomeIcon icon={['fab', 'twitter']} size="lg" />
                                </a>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
 
        </>
   )

}
